import './magazine-category.scss';

import Swiper from 'swiper';
import { Navigation, A11y, Pagination } from 'swiper/modules';

class MagazineCategory {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-magazine-category',
            sliderAttr: 'slider',
            slideAttr: 'slide'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$magazineCategory = $element;
        this.$magazineCategoryContainer = this.$magazineCategory.querySelector(`[${this.settings.initAttr}="${this.settings.sliderAttr}"]`);
        this.$magazineCategorySlides = this.$magazineCategory.querySelectorAll(`[${this.settings.initAttr}="${this.settings.slideAttr}"]`);
        this.magazineCategory = null;

        if (this.$magazineCategoryContainer && this.$magazineCategorySlides.length > 1) {
            this.initialize();
        }
    }

    initialize () {
        this.initSlider();
    }

    initSlider () {
        this.magazineCategory = new Swiper(this.$magazineCategoryContainer, {
            modules: [Navigation, Pagination, A11y],
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            slidesPerView: 'auto',
            speed: 500,
            a11y: {
                prevSlideMessage: 'Vorheriger Slide',
                nextSlideMessage: 'Nächster Slide',
                paginationBulletMessage: 'Springe zu Slide {{index}}',
                firstSlideMessage: 'Dies ist der Erste Slide',
                lastSlideMessage: 'Dies ist der Letzte Slide',
                slideLabelMessage: 'Slide {{index}} von {{slidesLength}}'
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },
            navigation: {
                prevEl: '.swiper-button-prev',
                nextEl: '.swiper-button-next'
            }
        });
    }

    destroySlider () {
        if (this.magazineCategory !== null) {
            this.magazineCategory.destroy(true, true);
            this.magazineCategory = null;
        }
    }
}

export { MagazineCategory };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$magazineCategory = $context.querySelectorAll('[data-magazine-category="root"]');
        for (let i = 0; i < $$magazineCategory.length; i++) {
            const $magazineCategory = $$magazineCategory[i];

            $magazineCategory.API = new MagazineCategory($magazineCategory);
        }
    }
});
